module.exports = "<div class=\"layout-content\">\n  <app-header></app-header>\n  <app-sidebar *ifRole=\"'ROLE_USER'\"></app-sidebar>\n  <div\n    [roleClass]=\"{ 'component-container-sidebar-padding': ['ROLE_USER'] }\"\n    class=\"component-container\"\n  >\n    <router-outlet></router-outlet>\n  </div>\n  <app-footer></app-footer>\n</div>\n<notify-container></notify-container>\n<app-cookie-info></app-cookie-info>\n"


//////////////////
// WEBPACK FOOTER
// /dist/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main